module.exports = __webpack_public_path__ + "img/date4-icon.661f2229.png";